import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles(() => ({
  cardButtonRoot: { // used for the upload button in several of the custom callout cards
    minWidth: 168,
  },
}));

export default useStyles;
